/**
 * Контекст текущей страницы ЛК для ИИ-чата (краткая сводка для пользователя / буфера обмена).
 */

function matchGroups(pathname, pattern) {
  const m = pathname.match(pattern)
  return m || null
}

function decodePathSegment(value) {
  try {
    return decodeURIComponent(String(value || ''))
  } catch {
    return String(value || '')
  }
}

/**
 * @param {string} pathname
 * @returns {{ entity: string, id?: string, summary: string, pathname: string }}
 */
export function buildAiPageContext(pathname) {
  const p = (pathname.split('?')[0] || '/').replace(/\/+$/, '') || '/'

  const employeeCardMatch = matchGroups(p, /^\/company\/team\/([^/]+)\/?$/)
  if (employeeCardMatch) {
    const employeeName = decodePathSegment(employeeCardMatch[1])
    if (!['new', 'income-report'].includes(employeeName)) {
      return {
        entity: 'employee',
        id: employeeName,
        summary: `Сотрудник: ${employeeName}`,
        pathname: p,
      }
    }
  }

  const entityRules = [
    [/^\/client\/([^/]+)\/?$/, 'client', 'Клиент'],
    [/^\/object\/([^/]+)\/?$/, 'object', 'Объект'],
    [/^\/contract\/([^/]+)\/?$/, 'contract', 'Договор'],
    [/^\/stage\/([^/]+)\/?$/, 'stage', 'Стадия'],
    [/^\/act\/([^/]+)\/?$/, 'act', 'Акт'],
  ]
  for (const [re, entity, label] of entityRules) {
    const m = matchGroups(p, re)
    if (m) {
      const id = decodePathSegment(m[1])
      return { entity, id, summary: `${label}: ${id}`, pathname: p }
    }
  }

  const sectionRules = [
    ['/company/clients', 'Раздел «Клиенты»'],
    ['/company/objects', 'Раздел «Объекты»'],
    ['/company/contracts', 'Раздел «Договоры»'],
    ['/company/stages', 'Раздел «Стадии»'],
    ['/company/acts', 'Раздел «Акты»'],
    ['/company/team', 'Раздел «Команда»'],
    ['/company/departments', 'Раздел «Подразделения»'],
    ['/admin/system-params', 'Параметры системы'],
    ['/settings', 'Настройки профиля'],
    ['/ai', 'Полный режим ИИ-ассистента'],
  ]
  for (const [prefix, summary] of sectionRules) {
    if (p === prefix || p.startsWith(`${prefix}/`)) {
      return { entity: 'section', summary, pathname: p }
    }
  }

  if (p.startsWith('/admin/')) {
    return { entity: 'admin', summary: 'Администрирование', pathname: p }
  }

  return { entity: 'lk', summary: 'Личный кабинет', pathname: p }
}

/**
 * Текст для подсказки агенту (вставка пользователем или копирование).
 * @param {{ summaryOverride?: string | null }} [options] — заменить строку сводки (напр. номер договора вместо UUID из URL)
 */
export function formatContextForPrompt(ctx, options = {}) {
  const url = typeof window !== 'undefined' ? window.location.href : ctx.pathname
  const summaryLine =
    options.summaryOverride != null && String(options.summaryOverride).trim() !== ''
      ? String(options.summaryOverride).trim()
      : ctx.summary
  return [
    '[Контекст страницы ЛК]',
    `Сущность: ${ctx.entity}${ctx.id ? `, id: ${ctx.id}` : ''}`,
    `Сводка: ${summaryLine}`,
    `URL: ${url}`,
  ].join('\n')
}
